<template>
  <div class="yxtbiz-check-item-selector">
    <div class="yxtbiz-check-item-selector__left">
      <div class="yxtbiz-check-item-selector__filter clearfix font-size-14">
        <yxt-popover
          :append-to-body="false"
          popper-class="yxtbiz-check-item-selector__popover"
          placement="bottom-start"
          :visible-arrow="false"
          v-model="showMoreFilter"
        >
          <yxt-button slot="reference" plain class="yxtbiz-filter-btn mr12">
            <yxt-svg
              width="20px"
              height="20px"
              icon-class="filter"
              class="v-top"
            />
            <span class="ml8 v-top">{{
              $t('pc_biz_common_lbl_moreFilter' /* 更多筛选 */)
            }}</span>
            <i
              class="ml8"
              :class="
                showMoreFilter ? 'yxt-icon-arrow-up' : 'yxt-icon-arrow-down'
              "
            ></i>
          </yxt-button>
          <yxt-form :inline="true">
            <yxt-row :gutter="20">
              <yxt-col :span="12">
                <yxt-form-item
                  label-width="114px"
                  :label="$t('pc_biz_shoptour_item_publish_time').d('检查项发布时间')"
                >
                  <yxt-date-picker
                    @change="changeDate"
                    v-model="publishDate"
                    format="yyyy-MM-dd"
                    type="daterange"
                    :range-separator="$t('pc_biz_shoptour_lbl_to').d('至')"
                    :start-placeholder="$t('pc_biz_shoptour_lbl_starttime').d('开始日期')"
                    :end-placeholder="$t('pc_biz_shoptour_lbl_endtime').d('结束日期')"
                  >
                  </yxt-date-picker>
                </yxt-form-item>
              </yxt-col>
              <yxt-col :span="12">
                <yxt-form-item
                  label-width="100px"
                  :label="$t('pc_biz_shoptour_item_cate').d('检查项分类')"
                >
                  <yxt-select
                    v-model="itemSearch.itemCatId"
                    clearable
                    size="large"
                    :placeholder="$t('pc_biz_shoptour_please_select').d('请选择')"
                    @change="changeCate"
                  >
                    <yxt-option
                      v-for="item in cateList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></yxt-option>
                  </yxt-select>
                </yxt-form-item>
              </yxt-col>
            </yxt-row>
          </yxt-form>
        </yxt-popover>
        <yxt-input
          style="width: 208px"
          :placeholder="$t('pc_biz_shoptour_search_by_item_name').d('请输入检查项名称')"
          v-model="itemSearch.searchKey"
          searchable
          @search="itemNameSearch"
          maxlength="100"
        >
        </yxt-input>
      </div>
      <div class="yxtbiz-check-item-selector__main mt16">
        <yxt-table
          :ref="refTable"
          class="yxtbiz-check-item-selector__table"
          v-loading="loading"
          :data="itemList"
          :height="tableHeight"
          @select-all="selectAll"
          @select="select"
          :default-sort="{ prop: 'releaseTime', order: 'desc' }"
          @sort-change="sortChange"
        >
          <yxt-table-column
            type="selection"
            :show-overflow-tooltip="false"
            width="30"
            align="right"
            clear-padding="left-right"
          ></yxt-table-column>
          <yxt-table-column
            show-overflow-tooltip
            :label="$t('pc_biz_shoptour_item_name').d('检查项名称')"
            prop="itemName"
            align="left"
            min-width="200"
          >
          </yxt-table-column>
          <yxt-table-column
            :label="$t('pc_biz_shoptour_publish_person').d('发布人')"
            show-overflow-tooltip
            popover-html
            prop="releaseUserName"
            align="left"
            width="100"
          >
            <template slot-scope="scope">
              <yxtbiz-user-name :name="scope.row.releaseUserName" />
            </template>
          </yxt-table-column>
          <yxt-table-column
            show-overflow-tooltip
            :label="$t('pc_biz_shoptour_task_publish_time').d('发布时间')"
            prop="releaseTime"
            sortable="custom"
            :formatter="shortDate"
            align="left"
            width="160"
          ></yxt-table-column>
        </yxt-table>
      </div>
      <yxt-row align="middle" class="yxtbiz-check-item-selector__mask mt16" type="flex">
        <yxt-row type="flex" align="middle" class="col-flex-1">
          <yxt-button
            v-if="showFilterAll"
            type="text"
            class="lh32 yxtbiz-check-item-selector__btn-search-all"
            :class="isSearchAll ? 'color-primary-4 disabled' : ''"
            @click="searchAll"
          >
            {{
              isCancelSelect
                ? $t('pc_biz_shoptour_btn_cancelFilter' /*取消筛选结果*/)
                : $t('pc_biz_shoptour_all_filter_results' /*全选筛选结果*/)
            }}
          </yxt-button>
          <div v-loading="isSearchAll" class="yxtbiz-check-item-selector__loading__all" />
        </yxt-row>
        <yxt-pagination
          :page-size="itemSearch.limit"
          :total="count"
          :current-page.sync="page"
          @current-change="pageChange"
          layout="total, prev, pager, next"
          :simple-total="false"
          :page-count="totalPage"
        ></yxt-pagination>
      </yxt-row>
    </div>
    <div class="yxtbiz-check-item-selector__right">
      <div class="yxtbiz-check-item-selector__right_count">{{$t('pc_biz_shoptour_select_info' /*已选择（{0}/{1}）*/, [selectedList.length, maxCount]).d(`已选择（${selectedList.length}/${maxCount}`)}}</div>
      <div style="height: 100%">
        <yxtbiz-virtual-list
          is-scrollbar
          style="height: 100%;overflow: hidden;"
          :data-sources="selectedList"
          data-key="itemId"
          :estimate-size="32"
          :keeps="50"
          item-tag="div"
        >
          <template slot-scope="{ source }">
            <yxt-tag
              @close="deleteItem(source)"
              size="small"
              type="info"
              class="mb5 tag"
              closable
              :key="source.itemId"
            >
              <span class="yxtbiz-user-selector-tag">{{ source.itemName }}</span>
            </yxt-tag>
          </template>
        </yxtbiz-virtual-list>
      </div>
      <yxt-button
        type="text"
        class="yxtbiz-user-clear font-size-12 color-gray-9 hover-primary-6"
        @click="clear"
        :disabled="Object.values(this.selected).length === 0"
        >{{ $t('pc_biz_shoptour_clear_all') }}</yxt-button
      >
    </div>
  </div>
</template>

<script>
import { getCheckItemList, getCheckItemCateList } from './service';
import resizeTable from '../mixins/resizeTable';
import dateUtil from 'yxt-biz-pc/src/utils/date';
import { Table, TableColumn, Pagination } from 'yxt-pc';
export default {
  name: 'YxtbizCheckItemSelector',
  components: {
    YxtPagination: Pagination,
    YxtTable: Table,
    YxtTableColumn: TableColumn
  },
  mixins: [resizeTable],
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      }
    },
    maxCount: { // 选择检查项数量限制
      type: Number,
      default: 1000
    },
    // 每页限制条数
    limit: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      refTable: 'stb',
      showMoreFilter: false,
      tableHeight: 0,
      page: 1,
      publishDate: [], // 发布时间
      startDate: [], // 开始时间
      endDate: [], // 结束时间
      itemList: [],
      // 来源
      cateList: [],
      itemSearch: {
        searchKey: '', // 搜索关键词
        limit: 50,
        offset: 0,
        orderby: 'release_time',
        direction: 'desc',
        itemCatId: ''
      },
      loading: false,
      totalPage: 0,
      count: 0,
      selectedList: [],
      selected: {},
      showFilterAll: true, // 是否显示筛选所有
      isSearchAll: false,
      isCancelSelect: false
    };
  },
  created() {
    this.formatModel(this.value);
    this.getCheckItemCateList();
    this.getCheckItemList();
  },
  methods: {
    changeDate() {
      this.itemSearch.releaseDateStart = this.publishDate
        ? this.shortDate(null, null, this.publishDate[0])
        : '';
      this.itemSearch.releaseDateEnd = this.publishDate
        ? this.shortDate(null, null, this.publishDate[1])
        : '';
      this.getCheckItemList(true);
    },
    changeCate() {
      this.getCheckItemList(true);
    },
    shortDate(row, col, val, index) {
      if (!val) return '--';
      if (typeof val === 'string') {
        val = val.replace(/-/g, '/');
      }
      return col && col.property === 'releaseTime' ? dateUtil.format(new Date(val), 'yyyy-MM-dd HH:mm') : dateUtil.format(new Date(val), 'yyyy-MM-dd');
    },
    // 获取分类列表
    getCheckItemCateList() {
      getCheckItemCateList().then(res => {
        this.cateList = res.datas ? res.datas : [];
      }).catch(e => {
        this.$message.error(e.error.message);
      });
    },
    getCheckItemList(isReset) {
      if (isReset) {
        this.page = 1;
        this.itemSearch.offset = 0;
      }
      this.itemSearch.limit = this.limit;
      this.itemSearch.searchKey = this.itemSearch.searchKey.trim();
      const {searchKey, limit, offset, orderby, direction, itemCatId} = this.itemSearch;
      const params = {
        direction,
        limit,
        offset,
        orderby
      };
      const data = {
        releaseDateStart: this.publishDate && this.publishDate[0] ? this.shortDate(null, null, this.publishDate[0]) : '',
        releaseDateEnd: this.publishDate && this.publishDate[1] ? this.shortDate(null, null, this.publishDate[1]) : '',
        itemCatId,
        searchKey
      };
      this.loading = true;
      getCheckItemList(params, data)
        .then(result => {
          // 有搜索结果展示全选筛选结果
          this.showFilterAll = result.datas.length !== 0;
          this.itemList = result.datas;
          this.totalPage = result.paging.pages;
          this.count = result.paging.count;
          this.loading = false;
          this.$nextTick(() => {
            this.setChecked();
          });
        })
        .catch(e => {
          this.loading = false;
          this.$message.error(e.error.message);
        });
    },
    // 选中全部筛选结果
    searchAll() {
      if (this.isCancelSelect) {
        // 取消全部筛选结果
        return this.cancelSelectAll();
      }
      if (this.selectedList.length >= this.maxCount) {
        this.$message.warning(this.$t('pc_biz_shoptour_item_limit', [this.maxCount]).d(`检查项数量不能超过${this.maxCount}`));
        return;
      }
      const limitCount = this.maxCount;
      const len = Math.ceil(this.count / limitCount);
      // let count = 0;
      this.itemSearch.limit = this.limit;
      this.itemSearch.searchKey = this.itemSearch.searchKey.trim();
      const {searchKey, orderby, direction, itemCateId} = this.itemSearch;
      const data = {
        releaseDateStart: this.publishDate && this.publishDate[0] ? this.shortDate(null, null, this.publishDate[0]) : '',
        releaseDateEnd: this.publishDate && this.publishDate[1] ? this.shortDate(null, null, this.publishDate[1]) : '',
        itemCateId,
        searchKey
      };
      if (len > 0) {
        this.isSearchAll = true;
      }
      // 分批请求门店数据
      // for (let i = 0; i < len; i++) {
      const params = {
        direction,
        limit: limitCount,
        offset: 0,
        orderby
      };
      getCheckItemList(params, data)
        .then((result) => {
          // count++;
          // if (count >= len) {
          this.isSearchAll = false;
          // this.isCancelSelect = true;
          // }
          const list = result.datas;
          for (let i = 0; i < list.length; i++) {
            if (Object.values(this.selected).length >= this.maxCount) {
              this.$message.warning(this.$t('pc_biz_shoptour_item_limit_part', [this.maxCount]).d(`部分检查项未被选中，因为选择的检查项数量已经超过${this.maxCount}`));
              break;
            }
            this.selected[list[i].itemId] = list[i];
          }
          // 此处处理一页没有请求完数据的情况，加提示
          if (result.paging.pages > 1) {
            this.$message.warning(this.$t('pc_biz_shoptour_item_limit_part', [this.maxCount]).d(`部分检查项未被选中，因为选择的检查项数量已经超过${this.maxCount}`));
          }
          this.outPut();
        })
        .catch((e) => {
          this.isSearchAll = false;
          this.$message({
            type: 'error',
            message: e.message || e.error.message
          });
        });
      // }
    },
    // 取消全部筛选结果
    cancelSelectAll() {
      const {searchKey, orderby, direction, itemCateId} = this.itemSearch;
      const params = {
        direction,
        limit: this.count,
        offset: 0,
        orderby
      };
      const data = {
        releaseDateStart: this.publishDate && this.publishDate[0] ? this.shortDate(null, null, this.publishDate[0]) : '',
        releaseDateEnd: this.publishDate && this.publishDate[1] ? this.shortDate(null, null, this.publishDate[1]) : '',
        itemCateId,
        searchKey
      };
      this.isSearchAll = true;
      // 此处获取全量数据
      getCheckItemList(params, data).then((res) => {
        this.isSearchAll = false;
        this.isCancelSelect = false;
        const list = res.datas;
        list.forEach((item) => {
          delete this.selected[item.itemId];
        });
        this.outPut();
      });
    },
    itemNameSearch() {
      this.getCheckItemList(true);
    },
    sortChange(sort) {
      this.itemSearch.direction = sort.order || 'desc';
      this.getCheckItemList();
      return false;
    },
    pageChange(page) {
      this.page = page;
      this.itemSearch.offset = (page - 1) * this.itemSearch.limit;
      this.getCheckItemList();
    },
    select(item, row) {
      let isAdd = item.some(v => {
        return v.itemId === row.itemId;
      });
      if (!isAdd) {
        delete this.selected[row.itemId];
      } else {
        if (this.selectedList.length >= this.maxCount) {
          this.$message.warning(this.$t('pc_biz_shoptour_item_limit', [this.maxCount]).d(`检查项数量不能超过${this.maxCount}`));
        } else {
          this.selected[row.itemId] = row;
        }
      }
      this.outPut();
    },
    selectAll(items) {
      let isAdd = items.length !== 0;
      if (isAdd && this.selectedList.length >= this.maxCount) {
        this.$message.warning(this.$t('pc_biz_shoptour_item_limit', [this.maxCount]).d(`检查项数量不能超过${this.maxCount}`));
      } else {
        this.itemList.forEach(obj => {
          if (!isAdd) {
            delete this.selected[obj.itemId];
          } else {
            Object.values(this.selected).length >= this.maxCount ? this.$message.warning(this.$t('pc_biz_shoptour_item_limit_part', [this.maxCount]).d(`部分检查项未被选中，因为选择的检查项数量已经超过${this.maxCount}`)) : this.selected[obj.itemId] = obj;
          }
        });
      }
      this.outPut();
    },
    deleteItem(item) {
      let row = item;
      for (let index = 0; index < this.itemList.length; index++) {
        const element = this.itemList[index];
        if (element.itemId === item.itemId) {
          row = element;
          break;
        }
      }
      if (row) {
        this.$refs['stb'].toggleRowSelection(row, false);
      }
      delete this.selected[item.itemId];
      this.$forceUpdate();
      this.outPut();
    },
    clear() {
      // let row = null;
      // for (const key in this.selected) {
      //   if (this.selected.hasOwnProperty(key)) {
      //     for (let index = 0; index < this.itemList.length; index++) {
      //       const element = this.itemList[index];
      //       if (element.itemId === key) {
      //         row = element;
      //         break;
      //       }
      //     }
      //     if (row) {
      //       this.$refs['stb'].toggleRowSelection(row, false);
      //     }
      //   }
      // }
      this.$refs['stb'].clearSelection();
      this.selected = {};
      this.outPut();
    },
    outPut() {
      this.selectedList = Object.values(this.selected);
      this.$emit('input', this.selectedList);
      this.$emit('select', this.selectedList);
    },
    setChecked() {
      this.itemList.forEach(obj => {
        if (this.selected.hasOwnProperty(obj.itemId)) {
          this.$refs['stb'].toggleRowSelection(obj, true);
        } else {
          this.$refs['stb'].toggleRowSelection(obj, false);
        }
      });
    },
    formatModel(v) {
      this.selected = {};
      v.forEach(obj => {
        this.selected[obj.itemId] = obj;
      });
      this.selectedList = Object.values(this.selected);
    }
  },
  watch: {
    value(v) {
      this.formatModel(v);
      this.setChecked();
    }
  }
};
</script>
